import { getCountryByHostname, isDesktop } from '@/helpers';
import { IngredientMetadata } from '@/models';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgIngredientsLandingPage',
  beforeRouteEnter(to, from, next) {
    if (getCountryByHostname(window.location.hostname).countryCode === 'CA') {
      next(c => c.$router.push({ name: Routes.PageNotFound }));
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$services.ui.setRecipeBannerExpanded(false);
    next();
  }
})
export default class CmgIngredientsLandingPage extends Vue { 
  doneLoading = false;
  lastIsDesktop = false;

  get isDesktop(): boolean {
    return isDesktop(this.$appStore.state);
  }
  
  @Watch('isDesktop', { immediate: true, deep: true })
  async onIsDesktopChanged(isDesktop: boolean) {
    if (this.lastIsDesktop !== isDesktop) {
      this.lastIsDesktop = isDesktop;
      this.doneLoading = false;
      this.doneLoading = await this.$services.monoMenu.awaitCacheItems();
    }
  }

  async mounted() {
    const isIngredientNavigation = this.$router.currentRoute.params['ingredientNavigation'];

    // This line  in CmgApp forces a full refresh, even on param change: router-view(:key="$route.fullPath")
    // We need to not reload on navigation between ingredients 
    if (!isIngredientNavigation) {
      window.scrollTo(0,0); // Hack to make the page pretty for new feature. scrollBehavior in router.ts is bugged
      this.doneLoading = await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
    } else {
      this.doneLoading = true;
    }
  }

  get showIngredientPanel(): boolean {
    return this.$appStore.state.ui.ingredientsPage.ingredientsPanelVisibility;
  }

  get isPageOnAEMCS(): boolean {
    const isAEMCS = window._cmgIsAEMCS ?? false;
    return (isAEMCS ?? true);
  }
}
